import axios from "axios";
import API from "./api";
import { sessionCookies } from "../utils/helpers";

const uuidv4 = require("uuid/v4");

const baseUrl = process.env.VUE_APP_BASE_URL;

function logoutUser() {
  // remove user from local storage to log user out
  sessionCookies.remove("token");
  localStorage.removeItem("token");
  localStorage.removeItem("user");
}

async function createUser(user) {
  user.uuid = uuidv4();
  await API().post("auth/register", user);
}

async function loginUser(credentials) {
  try {
    credentials.is_web = true;
    const res = await axios
      .post(`${baseUrl}auth/sign-in`, credentials)
      .then(user => {
        // login successful if there's a jwt token in the response
        if (!user || !user.data || !user.data.token) { return user; }

        // store user details and jwt token in local storage to keep user logged in between page refreshes
        sessionCookies.set("token", user.data.token);
        localStorage.setItem("token", user.data.token);
        localStorage.setItem("user", JSON.stringify(user.data));

        return user;
      });

    return res;
  } catch (err) {
    if (err) {
      console.error(err);
    }
  }
}

async function checkUserType(id) {
  return API().get(`auth/check-type/${id}`);
}

async function changePassword(id,payload) {
  return API().post(`auth/change-password/${id}`,payload);
}

export default {
  loginUser,
  logoutUser,
  createUser,
  checkUserType,
  changePassword
};
